import { styled } from "@mui/material/styles";
import { Button, Box } from "@mui/material";
import { formBg } from "../../../../constants/Home/feedback";

export const StyledBox = styled(Box)`
    width: 100%;
    max-width: 800px;
    height: 500px;
    background-image: url(${formBg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 24px;
    display: flex;
    overflow: hidden;
`;

export const FormContainer = styled(Box)(({ theme }) => ({
    width: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingInline: theme.spacing(6),
    gap: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
        width: "50%",
        paddingInline: theme.spacing(2),
    },
}));

export const BenefitsContainer = styled(Box)(({ theme }) => ({
    width: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingInline: theme.spacing(3),
    
    [theme.breakpoints.down("sm")]: {
        width: "100%",
        paddingInline: theme.spacing(2),
        marginTop: theme.spacing(4),
    },
}));

export const MobileFormContainer = styled(Box)(({ theme }) => ({
    width: "90%",
    maxWidth: 360,
    backgroundColor: "#E3C852",
    borderRadius: 16,
    padding: theme.spacing(3),
    boxShadow: theme.shadows[3],
    marginBottom: theme.spacing(4),
    marginInline: "auto",
    [theme.breakpoints.up("sm")]: {
        display: "none", 
    },
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
        marginTop: theme.spacing(1),
        backgroundColor: "#170C66",
        fontWeight: 700,
        paddingBlock: theme.spacing(1.5),
        borderRadius: theme.shape.borderRadius * 2,
        width: "100%",
        "&:hover": {
        backgroundColor: "#2A2D7D",
        },
}));